import axios from 'axios';

const apiUrlEvaGpt = process.env.IA_URL || 'https://api.evagpt.com.br';
const apiUrl = process.env.PORTAL_URL || 'http://localhost:7004';
const apiKey =
  process.env.IA_KEY || 'zpka_8bc52fa3215d43bd98ffff365bc3290c_60cae365';


export async function getIAResposta(text: string, conversationId?:string | null | undefined): Promise<any> { 
  if (!conversationId)  {
    conversationId = await getConversationId();

    const newConversationRequisition = await createIAConversation();

    if (newConversationRequisition?.status === 201)  {
      conversationId = newConversationRequisition?.data?.id;
    }
  }

  const response = await axios.post(
    `${apiUrl}/api/ia/conversation/stream/${conversationId}`,
    { text: text },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiKey}`,
      },
    }
  );

  return response?.data;
}

export async function createIAConversation(): Promise<any> {
  const response = await axios.post(
    `${apiUrlEvaGpt}/conversation/create/cm9dfft2n12e3gq12mle7hutp`,
    { },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiKey}`,
      },
    }
  );

  return response;
}

export async function getConversationId(): Promise<string | undefined> {
  const isCurrentSessionValid = checkConversationSessionLifetime();

  if (isCurrentSessionValid) {
    const conversationIdSession = localStorage.getItem("conversationId");
    if (conversationIdSession) {
      const conversationData = JSON.parse(conversationIdSession);

      return conversationData.conversationId;
    }
  } 
  const newConversationRequisition = await createIAConversation();

  if (newConversationRequisition?.status === 201) {
    const conversationId = newConversationRequisition?.data?.id;

    if (conversationId)
      renewConversationSession(conversationId)

    return conversationId || "v6m57mq3t7ukgmurxux47vzl";
  }
}

function checkConversationSessionLifetime(): boolean {
  const conversationIdSession = localStorage.getItem("conversationId");

  if (conversationIdSession) {
    const conversationData = JSON.parse(conversationIdSession || "{}");


    if (conversationData.timeStamp) {

      const currentTime = Date.now();
      const timeDifference = currentTime - conversationData.timeStamp;

      const sessionLifetime = 24 * 60 * 60 * 1000; // 24h in milliseconds

      return timeDifference < sessionLifetime;
    }
    return false
  }

  return false;
}

function renewConversationSession(conversationId: string): void {
  const conversationData = {
    conversationId: conversationId,
    timeStamp: Date.now(),
  };

  localStorage.setItem(
    "conversationId",
    JSON.stringify(conversationData)
  );
}

export async function sendFeedback(conversationId: string, feedback: number): Promise<any> {
  try {
    const response = await axios.post(
      `${apiUrl}/api/ia/conversation/survey/${conversationId}`,
      { nota: feedback },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
        },
      }
    );

    return response?.data;
  } catch (error) {
    console.error('Erro ao enviar feedback:', error);
    throw error;
  }
}
  
